import React from 'react';
import PropTypes from 'prop-types';

const YFInput = ({
    test_id,
    defaultValue,
    disabled,
    type,
    min,
    step,
    label,
    name,
    placeholder,
    register,
    pattern,
    error,
    auto_complete,
}) => {
    return (
        <>
            <label htmlFor={name}>{label}</label>
            <input
                test_id={test_id}
                min={min}
                step={step}
                disabled={!disabled}
                type={type}
                name={name}
                placeholder={placeholder}
                ref={register}
                defaultValue={defaultValue}
                pattern={pattern}
                autoComplete={auto_complete}
            />
        </>
    );
};
YFInput.propTypes = {
    // type: PropTypes.string.isRequired,
    // label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    // placeholder: PropTypes.string.isRequired,
};
YFInput.defaultProps = {
    disabled: true,
};
export default YFInput;
